// extracted by mini-css-extract-plugin
module.exports = {"activityHrCard":"activityHRCard_activityHrCard__1_XLV","activityHRGraph":"activityHRCard_activityHRGraph__2mVd9"};